import {KTSVG} from '../../../../../../_metronic/helpers/components/KTSVG'
import {useListView} from '../../core/ListViewProvider'

const RolesListGrouping = () => {
  const {selected, setSelected} = useListView()

  return (
    <div className='d-flex justify-content-end align-items-center'>
      <div className='fw-bold me-5'>
        <span className='me-2'>{selected.length}</span>
        Selected
      </div>

      <button
        type='button'
        className='btn btn-danger'
        onClick={() => setSelected([])}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' />
        Delete Selected
      </button>
    </div>
  )
}

export {RolesListGrouping} 